import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { DragHandle } from '../drag-handle/DragHandle';
import { PriorityBadge } from '../priority-badge/PriorityBadge';
import { StatusBadge, QueueStatus } from '../status-badge/StatusBadge';
import { QueueStat } from '../queue-stat/QueueStat';

export interface QueueCardRow1Props {
  priority: number;
  queueName: string;
  status: QueueStatus;
  totalInQueue: number;
  criticalAged: number;
  onDragStart?: (e: React.DragEvent<HTMLSpanElement>) => void;
  isDragging?: boolean;
}

export const QueueCardRow1: React.FC<QueueCardRow1Props> = ({
  priority,
  queueName,
  status,
  totalInQueue,
  criticalAged,
  onDragStart,
  isDragging = false
}) => {
  return (
    <Flex
      className="cmx-queue-card-row1"
      alignItems="center"
      gap="3"
      width="100%"
      data-testid="queue-card-row1"
    >
      <DragHandle onDragStart={onDragStart} isActive={isDragging} />
      <PriorityBadge position={priority} />
      <Text
        className="cmx-queue-card-row1__name"
        flex="1"
        fontWeight="600"
        fontSize="14px"
        noOfLines={1}
        title={queueName}
      >
        {queueName}
      </Text>
      {status !== 'healthy' && <StatusBadge status={status} />}
      <Flex className="cmx-queue-card-row1__stats" gap="6" ml="auto" flexShrink={0}>
        <QueueStat value={totalInQueue} label="Total in Queue" />
        <QueueStat
          value={criticalAged}
          label="Critical Aged"
          colorOverride="var(--color-queue-critical)"
        />
      </Flex>
    </Flex>
  );
};

QueueCardRow1.displayName = 'QueueCardRow1';
export default QueueCardRow1;
